$(function() {
  
  
	/*============
	NAVIGATION
	============*/
	$('[data-nav]').click(function(e) {
		e.preventDefault();
		$(this).toggleClass('bg-primary text-dark text-white').find('i').toggleClass('text-primary text-white');
		$('header nav').toggle();
	});
	$('[data-mobile-nav]').click(function(e) {
		e.preventDefault();
		$(this).find('i').toggleClass('fa-bars fa-times');
		$('#mobilenav').toggle();
	});

	$('#mobilenav .parent').on('click',function(e) {
		e.preventDefault();
		$(this).find('i').toggleClass('text-red fa-caret-up fa-caret-down');
      	$(this).prev().toggleClass('text-red')

        if($(this).closest('div').next().is(":hidden")) {
        $(this).closest('div').next().removeAttr('hidden');
        $(this).closest('div').next().attr('aria-expanded', 'true');
        $(this).closest('div').next().attr('aria-hidden', 'false');
      }
      else {
        $(this).closest('div').next().attr('hidden', true);
        $(this).closest('div').next().attr('aria-expanded', 'false');
        $(this).closest('div').next().attr('aria-hidden', 'true');
      }
      
	});
  
  	
  	
  
	/*============
	Search Toggle
	============*/
	$('[data-toggle-search]').click(function(e) {
		e.preventDefault();
		$(this).toggleClass('bg-primary text-medium text-white').find('i').toggleClass('text-primary text-white fa-search fa-times');
		$('header #search').toggleClass('hidden open');
	});


	/*==================
	AJAX Content
	==================*/
	$('[data-get]').each(function(index, item) {
		var url = $(item).data('get');
		$.ajax({
			url: url,
			type: 'get',
			cache: false,
			success: function(r) {
				$(item).html(r);
			}
		});
	});

	/*============
		Window Load START
	============
	jQuery(window).on('load', function() {
		jQuery('.loading-area').fadeOut(0)
	});*/
  
  	/*jQuery('.loading-area').fadeOut(100);*/

	/*============
	SLIDE SHOW
	============*/
	$('.slideshow-section').each(function() {
		var $dots = $(this).find('[data-dots]');
		$(this).find('[data-slides]').slick({
			arrows: false,
			dots: true,
			appendDots: $dots,
			adaptiveHeight: true,
			autoplay: true,
			autoplaySpeed: 6000
		});
	});

	/*============
	FEATURED PRODUCTS
	============*/
	$('[data-section-type="featured-products-section"]').each(function() {
		$(this).find('[data-tab]').click(function(e) {
			e.preventDefault();
			$(this).addClass('font-extra-bold text-primary').removeClass('text-medium').siblings().removeClass('font-extra-bold text-primary').addClass('text-medium');
			$('[data-arrows="' + $(this).data('tab') + '"]').removeClass('hidden').siblings().addClass('hidden');
			$('#' + $(this).data('tab')).removeClass('hidden').siblings().addClass('hidden');
			$('[data-carousel="' + $(this).data('tab') + '"]').slick('reinit');
		});
		$(this).find('select').change(function(e) {
			e.preventDefault();
			if ($(this).val() != "Select Category") {
				$('[data-tab="' + $(this).val() + '"]').click();
			}
		});
		$(this).find('[data-carousel]').each(function() {
			var $arrows = $('[data-arrows="' + $(this).data('carousel') + '"]');
			$(this).slick({
				prevArrow: $arrows.find('[data-prev]'),
				nextArrow: $arrows.find('[data-next]'),
				slidesToShow: 5,
				slidesToScroll: 5,
				infinite: false,
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3
						}
			    },
					{
						breakpoint: 991,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2
						}
			    },
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							centerMode: true,
							centerPadding: '60px'
						}
			    }
			]
			});
		});
	});

	/*============
	RELATED PRODUCTS
	============*/
	$('[data-section-type="related-products-section"]').each(function() {
		$(this).find('[data-tab]').click(function(e) {
			e.preventDefault();
			$(this).addClass('font-extra-bold text-primary').removeClass('text-medium').siblings().removeClass('font-extra-bold text-primary').addClass('text-medium');
			$('[data-arrows="' + $(this).data('tab') + '"]').removeClass('hidden').siblings().addClass('hidden');
			$('#' + $(this).data('tab')).removeClass('hidden').siblings().addClass('hidden');
			$('[data-carousel="' + $(this).data('tab') + '"]').slick('reinit');
		});
		$(this).find('select').change(function(e) {
			e.preventDefault();
			if ($(this).val() != "Select Category") {
				$('[data-tab="' + $(this).val() + '"]').click();
			}
		});
		$(this).find('[data-carousel]').each(function() {
			var $arrows = $('[data-arrows="' + $(this).data('carousel') + '"]');
			$(this).slick({
				prevArrow: $arrows.find('[data-prev]'),
				nextArrow: $arrows.find('[data-next]'),
				slidesToShow: 4,
				slidesToScroll: 4,
				infinite: false,
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3
						}
			    },
					{
						breakpoint: 991,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2
						}
			    },
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
			    }
			]
			});
		});
	});
  
  
  	/*============
	RELATED BLOG ARTICLES
	============*/
	$('[data-section-type="related-blog-articles-section"]').each(function() {
		$(this).find('[data-tab]').click(function(e) {
			e.preventDefault();
			$(this).addClass('font-extra-bold text-primary').removeClass('text-medium').siblings().removeClass('font-extra-bold text-primary').addClass('text-medium');
			$('[data-arrows="' + $(this).data('tab') + '"]').removeClass('hidden').siblings().addClass('hidden');
			$('#' + $(this).data('tab')).removeClass('hidden').siblings().addClass('hidden');
			$('[data-carousel="' + $(this).data('tab') + '"]').slick('reinit');
		});
		$(this).find('select').change(function(e) {
			e.preventDefault();
			if ($(this).val() != "Select Category") {
				$('[data-tab="' + $(this).val() + '"]').click();
			}
		});
		$(this).find('[data-carousel]').each(function() {
			var $arrows = $('[data-arrows="' + $(this).data('carousel') + '"]');
			$(this).slick({
				prevArrow: $arrows.find('[data-prev]'),
				nextArrow: $arrows.find('[data-next]'),
				slidesToShow: 4,
				slidesToScroll: 4,
				infinite: false,
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3
						}
			    },
					{
						breakpoint: 991,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2
						}
			    },
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
			    }
			]
			});
		});
	});
  
  
  /*============
	ADD-ONS PRODUCTS
	============*/
	$('[data-section-type="product-add-ons-section"]').each(function() {
		$(this).find('[data-tab]').click(function(e) {
			e.preventDefault();
			$(this).addClass('font-extra-bold text-primary').removeClass('text-medium').siblings().removeClass('font-extra-bold text-primary').addClass('text-medium');
			$('[data-arrows="' + $(this).data('tab') + '"]').removeClass('hidden').siblings().addClass('hidden');
			$('#' + $(this).data('tab')).removeClass('hidden').siblings().addClass('hidden');
			$('[data-carousel="' + $(this).data('tab') + '"]').slick('reinit');
		});
		$(this).find('select').change(function(e) {
			e.preventDefault();
			if ($(this).val() != "Select Category") {
				$('[data-tab="' + $(this).val() + '"]').click();
			}
		});
		$(this).find('[data-carousel]').each(function() {
			var $arrows = $('[data-arrows="' + $(this).data('carousel') + '"]');
			$(this).slick({
				prevArrow: $arrows.find('[data-prev]'),
				nextArrow: $arrows.find('[data-next]'),
				slidesToShow: 4,
				slidesToScroll: 4,
				infinite: false,
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3
						}
			    },
					{
						breakpoint: 991,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2
						}
			    },
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
			    }
			]
			});
		});
	});

  
  
  
	/*============
	Swatch Change Trigger
	============*/
    $('.swatch :radio').change(function() {
      var optionIndex = $(this).closest('.swatch').attr('data-option-index');
      var optionValue = $(this).val();
      $(this)
        .closest('form')
        .find('.single-option-selector')
        .eq(optionIndex)
        .val(optionValue)
        .trigger('change');
    });
  
  
  
  
  
	/*============
	PLANT OF THE WEEK
	============*/
	$('[data-section-type="plant-of-the-week-section"]').each(function() {
		$(this).find('[data-carousel]').each(function() {
			var $arrows = $('[data-arrows="' + $(this).data('carousel') + '"]');
			$(this).slick({
				prevArrow: $arrows.find('[data-prev]'),
				nextArrow: $arrows.find('[data-next]'),
				slidesToShow: 5,
				slidesToScroll: 5,
				infinite: false,
				responsive: [
					{
						breakpoint: 3200,
						settings: "unslick"
			    },
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2
						}
			    },
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
			    }
			]
			});
		});
	});
  	
  	/*============
	Defer Background Image (Homepage)
	============*/
  	initBackgroundImage()

	/*============
	ADD TO CART
	============*/
	initAddToCart();

	/*============
	TABS
	============*/
	$('[data-tab]').click(function(e) {
		e.preventDefault();
		$(this).addClass('text-primary font-extra-bold').removeClass('text-medium').siblings().removeClass('text-primary font-extra-bold').addClass('text-medium');
		$('#' + $(this).data('tab')).removeClass('hidden').siblings('div').addClass('hidden');
	});
	$('.tab-content [data-tab]').click(function(e) {
		e.preventDefault();
		$(this).removeClass('text-primary font-extra-bold').siblings().removeClass('text-medium');
		$(this).addClass('text-white bg-primary').removeClass('text-dark').siblings().removeClass('text-white bg-primary');
		$(this).children('i').addClass('fa-arrow-up text-white').removeClass('fa-arrow-down text-primary');
		$(this).siblings().children('i').removeClass('fa-arrow-up text-white').addClass('fa-arrow-down text-primary');
	});

	/*============
	FAQ
	============*/
	initFaqs();

	/*============
	GALLERY
	============*/
	if ($('[data-gallery]').length) {
		var $dots = $(this).find('[data-dots]');
		$(this).find('[data-gallery]').slick({
			arrows: false,
			dots: true,
			appendDots: $dots,
			adaptiveHeight: true,
			autoplay: true,
			autoplaySpeed: 6000
		});
	}

	/*============
	BLOCK PAGINATION
	============*/
	if ($('[data-paginate]').length) {
		$('[data-paginate]').each(function(i, el) {
			initPagination(el);
		});
	}

	/*============
	QUANTITY
	============*/
  	//Zach Test
   $('.qtybox .btnqty').on('click', function(){
          var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
          if($(this).hasClass('qtyplus')) {
            qty++;
          }else {
            if(qty > 1) {
              qty--;
            }
          }
          qty = (isNaN(qty))?1:qty;
          $(this).parent('.qtybox').find('.quantity-input').val(qty);
         if($('#ProductSelect-product-template option:selected').attr('data-qty') > 0 || $('#ProductSelect-product-template option:selected').attr('data-qty') == '') {
              $('#AddToCart').prop('disabled', false).removeClass('soldout').removeClass('failed');
              $('#AddToCartText').html(theme.strings.addToCart);
              $('.errors').remove();
              $('.shopify-payment-button').show();
         }
        }); 
  	
  	
	/*===============
	PRE_ORDER TO CART
	=================*/
        
  	$('#pre-order').click(function(e) {
      if($('#products>.pre').hasClass('hidden')) {
      	$('#products>.pre').removeClass('hidden');
      	$('#preOrderShipping').removeClass('hidden');
      	$('#products>.now').addClass('hidden');
      	$('#pre-order').addClass('btnActive');
      	$('#ship-now').removeClass('btnActive');
      }
  	});
  
    $('#ship-now').click(function(e) {
      if($('#products>.now').hasClass('hidden')) {
      	$('#products>.now').removeClass('hidden');
      	$('#preOrderShipping').addClass('hidden');
      	$('#products>.pre').addClass('hidden');
      	$('#ship-now').addClass('btnActive');
      	$('#pre-order').removeClass('btnActive');
      }
  	});
  
  $('#acknowledgePreOrder').change(function(e) {
    if ($('#acknowledgePreOrder').prop( "checked" )) {
      $('#checkouts').removeClass('hidden');
    }
    else {
      $('#checkouts').addClass('hidden');
    }
  });
  

	/*============
	LOGIN
	============*/
	if ($('[data-login]').length) {
		var config = {
			recoverPasswordForm: '#RecoverPassword',
			hideRecoverPasswordLink: '#HideRecoverPasswordLink'
		};

		if (!$(config.recoverPasswordForm).length) {
			return;
		}

		checkUrlHash();
		resetPasswordSuccess();

		$(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
		$(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);
	}

	/*============
	ADDRESSES
	============*/
	if ($('[data-addresses]').length) {
		var $newAddressForm = $('#AddressNewForm');

		if (!$newAddressForm.length) {
			return;
		}

		// Initialize observers on address selectors, defined in shopify_common.js
		if (Shopify) {
			new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
				hideElement: 'AddressProvinceContainerNew'
			});
		}

		// Initialize each edit form's country/province selector
		$('.address-country-option').each(function() {
			var formId = $(this).data('form-id');
			var countrySelector = 'AddressCountry_' + formId;
			var provinceSelector = 'AddressProvince_' + formId;
			var containerSelector = 'AddressProvinceContainer_' + formId;

			new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
				hideElement: containerSelector
			});
		});

		// Toggle new/edit address forms
		$('.address-new-toggle').on('click', function() {
			$newAddressForm.toggleClass('hidden');
		});

		$('.address-edit-toggle').on('click', function() {
			var formId = $(this).data('form-id');
			$('#EditAddress_' + formId).toggleClass('hidden');
		});

		$('.address-delete').on('click', function() {
			var $el = $(this);
			var formId = $el.data('form-id');
			var confirmMessage = $el.data('confirm-message');
			if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
				Shopify.postLink('/account/addresses/' + formId, { parameters: { _method: 'delete' } });
			}
		});
	}

  // Zach - Add sticky nav
  	var abar = document.getElementById("announcebar");
  	var abar_offsetHeight = abar.offsetHeight;
  
    var navbar = document.getElementById("navbar");
  	var navbar_offsetHeight = navbar.offsetHeight;
  
    var header = document.getElementById("shopify-section-header");
  	var header_clientHeight = header.clientHeight;
  
    var sticky = header_clientHeight - navbar_offsetHeight;
  
  	$('#shopify-section-header').css("padding-top", abar_offsetHeight);
  
    $(window).on( 'scroll resize', function(){
      abar_offsetHeight = abar.offsetHeight;
      navbar_offsetHeight = navbar.offsetHeight;
      header_clientHeight = header.offsetHeight;
	  sticky = header_clientHeight - abar_offsetHeight - navbar_offsetHeight;
    //   if ($( "#navbar" ).hasClass( "stickyNav" )) {
    //     sticky = header_clientHeight - abar_offsetHeight;
    //   }
    //   else {
    //     sticky = header_clientHeight - abar_offsetHeight - navbar_offsetHeight;
    //   }
            
      $('#shopify-section-header').css("padding-top", abar_offsetHeight);
      
      if (window.pageYOffset > sticky) {
        $('#navbar').addClass("stickyNav");
        //$('#navbar').css("top", abar_offsetHeight - 1);
        $('#mobilenav').addClass("stickyMobileNav");
        //$('#mobilenav').css("top", abar_offsetHeight + navbar_offsetHeight - 1);
		//$('body').addClass("cc-sticky-header-active");
        //$('main').css("padding-top", 0);
        $('#floatCart').removeAttr("hidden");
        $('#scrollTop').removeAttr("hidden");
      } else {
        $('#navbar').removeClass("stickyNav");
        //$('#navbar').css("top", "");
        $('#mobilenav').removeClass("stickyMobileNav");
        //$('#mobilenav').css("top", "");
		//$('body').removeClass("cc-sticky-header-active");
        $('#floatCart').attr("hidden", true);
        $('#scrollTop').attr("hidden", true);
        $('main').css("padding-top", "");
      }
    });



	// End Document Ready
});

$( '*' ).on("focus hover",function() {
  if($(this).hasClass('nav-link') || $(this).hasClass('child-link') || $(this).hasClass('grand-link')){
    if($(this).hasClass('nav-link')) {
      if(!$(this).siblings('.drop-menu-container').hasClass('flex')) {
        $("div.drop-menu-container").each(function() {
          $(this).removeClass('flex');
          $(this).attr('aria-hidden', true);
          $(this).attr('aria-expanded', false);
        });
        $(this).siblings('.drop-menu-container').addClass('flex');
          $(this).siblings('.drop-menu-container').attr('aria-hidden', false);
		  $(this).siblings('.drop-menu-container').attr('aria-expanded', true);
      }

    }
    if($(this).hasClass('child-link') || $(this).hasClass('grand-link')) {
      if(!$(this).closest('.drop-menu-container').hasClass('flex')) {
        $(this).closest('.drop-menu-container').addClass('flex');
        $(this).closest('.drop-menu-container').attr('aria-hidden', false);
        $(this).closest('.drop-menu-container').attr('aria-expanded', true);
      }
    }
  }
  else {
    $("div.drop-menu-container").each(function() {
       $(this).removeClass('flex');
       $(this).attr('aria-hidden', true);
       $(this).attr('aria-expanded', false);
     });
  }
});

$( '.growzone input' ).on("focus hover",function() {
  $(this).closest('.drop-menu-container').addClass('flex');
  $(this).closest('.drop-menu-container').attr('aria-hidden', false);
  $(this).closest('.drop-menu-container').attr('aria-expanded', true);
});

$( '.growzone button' ).on("focus hover",function() {
  $(this).closest('.drop-menu-container').addClass('flex');
  $(this).closest('.drop-menu-container').attr('aria-hidden', false);
  $(this).closest('.drop-menu-container').attr('aria-expanded', true);
});

function initFaqs() {
	$('.faq h3').unbind('click').click(function(e) {
		e.preventDefault();
		$(this).toggleClass('bg-light bg-primary').find('i').toggleClass('fa-arrow-down fa-arrow-up');
		$(this).next().toggleClass('hidden');
	});
	$('.PGQuestion h2').unbind('click').click(function(e) {
		e.preventDefault();
		$(this).find('i').toggleClass('fa-caret-down fa-caret-up');
		$(this).next().toggleClass('hidden');
	});
	$('[data-filter]').unbind('change').change(function(e) {
		var $block = $(this).parents('[data-filters]').siblings('[data-paginate]');
		e.preventDefault();
		$.ajax({
			url: $(this).val(),
			method: 'get',
			success: function(r) {
				$block.html(r);
				initPagination($block);
				initFaqs();
			}
		});
	});
	$('[data-filter-search]').unbind('submit').submit(function(e) {
		var $block = $(this).parents('[data-filters]').siblings('[data-paginate]');
		e.preventDefault();
		$.ajax({
			url: $(this).attr('action'),
			data: $(this).serialize(),
			method: 'get',
			success: function(r) {
				$block.html(r);
				initPagination($block);
				initFaqs();
			}
		});
	});
}

function initAddToCart() {
	$('.btn-select').click(function(e) {
		e.preventDefault();
		$(this).toggleClass("btn-select btn-add").find('i').toggleClass('fa-plus fa-minus');
		$(this).next('[data-variants]').toggleClass('hidden');
	});
}

function initPagination(block) {
	$(block).find('[data-pages] a').click(function(e) {
		var $block = $(this).parents('[data-paginate]');
		e.preventDefault();
		$.ajax({
			url: $(this).attr('href'),
			method: 'get',
			success: function(r) {
				$block.html(r);
				initPagination($block);
				initFaqs();
			}
		});
	});
}

// Account Pages

function onShowHidePasswordForm(evt) {
	evt.preventDefault();
	toggleRecoverPasswordForm();
}

function checkUrlHash() {
	var hash = window.location.hash;

	// Allow deep linking to recover password form
	if (hash === '#recover') {
		toggleRecoverPasswordForm();
	}
}

/**
 *  Show/Hide recover password form
 */
function toggleRecoverPasswordForm() {
	$('#RecoverPasswordForm').toggleClass('hidden');
	$('#CustomerLoginForm').toggleClass('hidden');
}

/**
 *  Show reset password success message
 */
function resetPasswordSuccess() {
	var $formState = $('.reset-password-success');

	// check if reset password form was successfully submited.
	if (!$formState.length) {
		return;
	}

	// show success message
	$('#ResetSuccess').removeClass('hidden');
}

$(function() {
	// product image slider //
	$('.slider').slick({
      	lazyLoad: 'ondemand',
        mobileFirst: true,
  		infinite: false,
		arrows: false,
		dots: false
	});

	$('.slider-nav-thumbnails').slick({
      	lazyLoad: 'ondemand',
        mobileFirst: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		asNavFor: '.slider',
		focusOnSelect: true
	});

	//remove active class from all thumbnail slides
	$('.slider-nav-thumbnails .slick-slide').removeClass('slick-active');

	//set active class to first thumbnail slides
	$('.slider-nav-thumbnails .slick-slide').eq(0).addClass('slick-active');
});

$(function() {
	$('.cart-addons .ajax-quick-add').each(function() {
		$(this).on('click', function(e) {
			e.preventDefault();
			$(this).prop('disabled', true);

			var productId = $(this).data('id');
			$.ajax({
				method: 'POST',
				url: '/cart/add',
				data: {
					id: productId
				},
				success: function() {
					window.location.href = '/cart';
				},
				error: function() {
					window.location.href = '/cart';
				}
			});
		});
	});
});

// Envision - guarantee/protection popup
$(function() {
	$('.popup .close-button').on('click', function(event) {
		event.preventDefault();
		$(this).parents('.popup').removeClass('open');
	});

	$('body').on('click', '.popup', function(event) {
		var target = $(event.target);
		if (!target.closest('.popup-content-container').length && $(this).hasClass('open')) {
			$(this).removeClass('open');
		}
	});

	$('body').on('click', '.open-guarantee-popup', function(event) {
		event.preventDefault();
		$('.popup.guarantee-popup').first().addClass('open');
	});
  
  	$('body').on('click', '.open-protection-popup', function(event) {
		event.preventDefault();
		$('.popup.protection-popup').first().addClass('open');
	});
});

// Envision - automatically update cart quantities on change, instead of update button
$(function() {
	$('.cart-container form[action="/cart"] input.cart-quantity-input').on('change', function() {
		$(this).closest('form').submit();
	});
});

// Envision - show/hide gift message if checkbox is checked
$(function() {
	if ($('.is-gift-checkbox').length) {
		$('.is-gift-checkbox').on('change', function(e) {
			//console.log($(this).parents('.gift-message-component').find('.gift-message-container'));
			$(this).parents('.gift-message-component').find('.gift-message-container').toggleClass('hidden', !$(this).is(':checked'));

			if (!$(this).is(':checked')) {
				$(this).parents('.gift-message-component').find('.gift-message-container textarea').val('');
			}
		});
	}
});

function initBackgroundImage() {
  var imgDefer = document.querySelectorAll('div[data-src]');
  var style = "background-image: url({url});background-color:#1f180b;";
  for (var i = 0; i < imgDefer.length; i++) {

    imgDefer[i].setAttribute('style', style.replace("{url}", imgDefer[i].getAttribute('data-src')));

  }
}

// Envision - California residents
/*$(function() {
	$.getJSON('https://ipinfo.io/json').done(function(data) {
		if (window.JSON.parse(JSON.stringify(data, null, 2)).region == "California") {
			$('.cali-residents').addClass('show')
		} else {
			$('.cali-residents').removeClass('show')
		}
	});
});*/

// Zach - Add sticky nav
/*var navbar = document.getElementById("navbar");
var sticky = navbar.offsetTop;

window.onscroll = function() { stickyNav() };
function stickyNav() {
  if (window.pageYOffset >= sticky) {
    $('#navbar').addClass("stickyNav");
    $('#mobilenav').addClass("stickyMobileNav");
    $('main').addClass("stickyPadding");
    $('#floatCart').removeAttr("hidden");
    $('#scrollTop').removeAttr("hidden");
  } else {
    $('#navbar').removeClass("stickyNav");
    $('#mobilenav').removeClass("stickyMobileNav");
    $('#floatCart').attr("hidden", true);
    $('#scrollTop').attr("hidden", true);
    $('main').removeClass("stickyPadding");
  }
}*/